import { HTTP_INTERCEPTORS } from "@angular/common/http";
import {
  ModuleWithProviders, NgModule,
  Optional,
  SkipSelf
} from "@angular/core";
import { AuthInterceptor } from "./auth/service/auth-interceptor/auth.interceptor.service";

@NgModule({
  imports: [
  ],
  providers: [],
})
export class CoreModule {
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule,
  ) {
  }

  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      ],
    };
  }
}
